import { useMemo, useState } from 'react';
import { Plus, Search, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { FAQ as ITEMS } from '@/data/faq';
import Reveal from '@/components/Reveal';

export default function FAQ() {
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return ITEMS;
    return ITEMS.filter(
      (i) =>
        i.question.toLowerCase().includes(q) || i.answer.toLowerCase().includes(q),
    );
  }, [query]);

  return (
    <section id="faq" className="section section-divider scroll-mt-24 bg-paper">
      <div className="container-site">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <Reveal>
              <h2 className="h2">Коротко о&nbsp;главном</h2>
              <p className="lead mt-6 max-w-md">
                Не нашли ответ на свой вопрос? Напишите нам на{' '}
                <a href="mailto:resstrosaas@mail.ru" className="link">
                  resstrosaas@mail.ru
                </a>{' '}
                или в{' '}
                <a
                  href="https://wa.me/79894734322"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="link"
                >
                  WhatsApp
                </a>
                , ответим в течение рабочего дня.
              </p>
            </Reveal>

            <Reveal delay={140}>
              <Link to="/support" className="btn-light mt-8 px-5 py-3 text-[13px] shadow-soft">
                Все материалы поддержки
                <span className="btn-icon">
                  <ArrowRight size={13} strokeWidth={2} />
                </span>
              </Link>
            </Reveal>
          </div>

          <div className="md:col-span-7 md:pl-8">
            <Reveal>
              <label className="flex items-center gap-3 rounded-2xl border border-line bg-white px-5 py-4 shadow-hair transition-shadow focus-within:shadow-lift">
                <Search size={16} strokeWidth={1.75} className="shrink-0 text-ink/40" />
                <input
                  type="search"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Найти ответ, например «оплата» или «54-ФЗ»"
                  className="w-full bg-transparent text-[14px] text-ink outline-none placeholder:text-ink/40"
                />
              </label>
            </Reveal>

            <div className="mt-3 rounded-3xl border border-line bg-white px-2 shadow-soft sm:px-3">
              {filtered.length === 0 && (
                <div className="py-8 text-center text-[13px] text-ink/50">
                  Ничего не нашли. Напишите нам в{' '}
                  <a
                    href="https://wa.me/79894734322"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link"
                  >
                    WhatsApp
                  </a>
                  .
                </div>
              )}
              {filtered.map((item, idx) => (
                <Reveal key={item.question} delay={idx * 30}>
                  <details className="group border-b border-line/70 py-6 px-3 last:border-b-0 open:pb-7 sm:px-5">
                    <summary className="flex cursor-pointer list-none items-start justify-between gap-6">
                      <span className="text-[17px] font-medium leading-snug text-ink">
                        {item.question}
                      </span>
                      <span className="mt-1 grid h-7 w-7 shrink-0 place-items-center rounded-full bg-paper text-ink/50 transition-transform group-open:rotate-45 group-open:bg-orange/10 group-open:text-orange">
                        <Plus size={17} strokeWidth={1.6} />
                      </span>
                    </summary>
                    <p className="mt-4 max-w-xl text-sm leading-relaxed text-ink/60">
                      {item.answer}
                    </p>
                  </details>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
